import { Box, Container, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconNotes } from 'assets/img';
import { TitleWithText } from '../utils/title-with-text';

type ShiftDescriptionTooltipProps = {
  descriptionShort: string;
  descriptionLong: string;
  descriptionLawRequirements: string;
  showLawRequirements?: boolean;
};

export const ShiftDescriptionTooltip = ({
  descriptionShort,
  descriptionLong,
  descriptionLawRequirements,
  showLawRequirements = true,
}: ShiftDescriptionTooltipProps) => {
  return (
    <Tooltip
      title={
        <Container>
          <TitleWithText title="Korte omschrijving" content={descriptionShort} />
          <TitleWithText title="Lange omschrijving" content={descriptionLong} />
          {showLawRequirements ? (
            <TitleWithText title="Afspraken en vereisten" content={descriptionLawRequirements} />
          ) : null}
        </Container>
      }
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <StyledNotesIcon />
        <Typography noWrap variant="subtitle2">
          Beschrijving
        </Typography>
      </Box>
    </Tooltip>
  );
};

const StyledNotesIcon = styled(IconNotes)(({ theme }) => ({
  opacity: 0.6,
  marginRight: theme.spacing(3),
  flexShrink: 0,
  width: 24,
  height: 24,
}));
